
import React from 'react';



function InputReview({ type, label, value, id, onChange, required }) {

    return (

        <div className="input-container">
            <div className="input-group">
                <input type={type} name={id} id={id} className="input-group__input" required={required} value={value} onChange={onChange} />
                <label htmlfor="name" className="input-group__label">{label}</label>
            </div>
        </div>
    );
}

export default InputReview;